import { browserHistory } from 'react-router';
import { routeLocationDidUpdate, routeHashDidUpdate } from 'actions/locationActions';
import { fireWebtrendsPageView, getWebTrendsEventType, hash2Obj } from 'utils/utils';

export default function initializeBrowserHistoryListener(store, config = {}) {
  const settings = {
    isUpdateWebtrendsEnabled: false,
  };

  const previous = {
    pathname: '',
    hash: '',
  };

  function updateStore(location, locationChanged, hashChanged) {
    if (locationChanged) store.dispatch(routeLocationDidUpdate(location));
    if (hashChanged) store.dispatch(routeHashDidUpdate(location));
  }

  function updateWebtrends(location, locationChanged, hashChanged, vievHashAttrExists) {
    const onPandaPage = location.pathname.includes('/holidays/availability/');

    if (hashChanged && (!locationChanged || vievHashAttrExists) && onPandaPage) {
      fireWebtrendsPageView(getWebTrendsEventType(location.hash));
    }
  }

  function hasChanged(location, type) {
    const changed = location[type] !== previous[type];
    if (changed) previous[type] = location[type];
    return changed;
  }

  function onLocationChange(location) {
    const vievHashAttrExists = !!hash2Obj(previous.hash).view;
    const hashChanged = hasChanged(location, 'hash');
    const locationChanged = hasChanged(location, 'pathname');

    updateStore(location, locationChanged, hashChanged);

    if (settings.isUpdateWebtrendsEnabled) {
      updateWebtrends(location, locationChanged, hashChanged, vievHashAttrExists);
    }
  }

  if (config.isUpdateWebtrendsEnabled === false) {
    settings.isUpdateWebtrendsEnabled = false;
  }

  browserHistory.listen(onLocationChange);
}



/** WEBPACK FOOTER **
 ** ./src/initializeBrowserHistoryListener.js
 **/